export default __webpack_public_path__ + "static/document-training-fe8f70cbfdf903013f958609a8b75e97.jpg";